import { useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import { Actions, onKeyDownForm, isDateValid } from "../../utils";
import DefaultButton from "../widgets/default-button";
import { DatePicker, Image } from "antd";
import dayjs from "dayjs";
import "../../assets/scss/components/modal.scss";
import isURL from "validator/lib/isURL";

interface MemberModel {
  member_url?: boolean;
  bio_url?: boolean;
  fan_url?: boolean;
  merch_url?: boolean;
}

export const MemberModal: React.FC<any> = (props) => {
  const [birthDateValid, setBirthDateValid] = useState(true);
  const [deathDateValid, setDeathDateValid] = useState(true);
  const [urlValidationStatus, setUrlValidationStatus] = useState<any>({
    member_url: false,
    bio_url: false,
    fan_url: false,
    merch_url: false,
  });
  const {
    show,
    model,
    setModel,
    closeModal,
    saveModal,
    mkey = "",
    memberTypeList,
    genderList,
    countryList,
    roleList,
  } = props;

  const isUrlValid = (field: string) => {
    return urlValidationStatus[field];
  };

  const handleUrlValidation = (e: string = "") => {
    if (e && model[e]) {
      if (isURL(model[e])) {
        setUrlValidationStatus((prevStatus: MemberModel) => ({
          ...prevStatus,
          [e]: false,
        }));
      } else {
        setUrlValidationStatus((prevStatus: MemberModel) => ({
          ...prevStatus,
          [e]: true,
        }));
      }
    }
    return true;
  };

  return (
    <>
      <Modal
        show={show}
        key={"modal_" + mkey}
        size="lg" //'sm' | 'lg' | 'xl'
        backdrop="static"
        onHide={closeModal}
        centered
        className="custom-modal member-modal"
      >
        <Form
          noValidate
          className="custom-form"
          onSubmit={saveModal}
          onKeyDown={onKeyDownForm}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {model.action === Actions.add ? "New" : model.action === Actions.edit ? "Edit" : "Delete"}
              {model.standard_role_id === 43
                ? " Artist"
                : model.standard_role_id === 13
                  ? " Composer"
                  : model.standard_role_id === 33
                    ? " Lyricist"
                    : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={6} md={3}>
                <div
                  className={
                    "img-preview " +
                    (!model.validate && !model.avatar ? "error" : "")
                  }
                >
                  <div className="image-wrapper">
                    <Image
                      width={120}
                      height={120}
                      src={
                        model.avatar ? model.avatar : "/imgs/Default-avatar.jpg"
                      }
                    />
                  </div>
                  <Form.Control
                    disabled={model.action === Actions.delete}
                    className="file-select"
                    type="file"
                    onChange={(e: any) => {
                      let file = e.target.files[0];
                      var reader = new FileReader();
                      reader.onload = function (ee: any) {
                        setModel({
                          ...model,
                          avatar_file: file,
                          avatar: ee.target.result,
                        });
                      };
                      reader.readAsDataURL(file);
                    }}
                  />
                  <div className="error-label">
                    <h5>upload</h5>
                  </div>
                </div>
              </Col>
              <Col xs={6} md={9}>
                {model.message !== "" ? (
                  <Row className="form-error">
                    <Form.Label>{model.message}</Form.Label>
                  </Row>
                ) : (
                  <></>
                )}
                <Row>
                  {/* name */}
                  <Form.Group className="col-9">
                    <Form.Label>
                      Name<span className="required">*</span>
                    </Form.Label>
                    <Form.Control
                      required
                      disabled={model.action === Actions.delete}
                      type="text"
                      value={model.used_name === 1 ? model.title : model.alias}
                      onChange={(e) =>
                        setModel({
                          ...model,
                          title: model.used_name === 1 ? e.target.value : "",
                          alias: model.used_name === 2 ? e.target.value : "",
                        })
                      }
                      isInvalid={
                        !model.validate &&
                        ((model.used_name === 1 && model.title === "") ||
                          (model.used_name === 2 && model.alias === ""))
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      Name can not empty.
                    </Form.Control.Feedback>
                  </Form.Group>
                  {/* gender */}
                  <Form.Group className="col-3">
                    <Form.Label>
                      Gender<span className="required">*</span>
                    </Form.Label>
                    <Form.Select
                      required
                      disabled={model.action === Actions.delete}
                      value={model.gender_id}
                      onChange={(e) =>
                        setModel({ ...model, gender_id: e.target.value })
                      }
                    >
                      {genderList?.map((m: any, index: number) => (
                        <option key={index} value={m.id}>
                          {m.title}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Row>
                {/* type, role */}
                <Row className="mt-3">
                  <Form.Group className="col-6">
                    <Form.Label>
                      Type<span className="required">*</span>
                    </Form.Label>
                    <Form.Select
                      required
                      disabled={model.action === Actions.delete}
                      value={model.member_type_id}
                      onChange={(e) =>
                        setModel({ ...model, member_type_id: e.target.value })
                      }
                    >
                      {memberTypeList?.map((m: any, index: number) => (
                        <option key={index} value={m.id}>
                          {m.title}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="col-6">
                    <Form.Label>
                      Usual Role<span className="required">*</span>
                    </Form.Label>
                    <Form.Select
                      required
                      // disabled={true}
                      disabled={model.action === Actions.delete}
                      value={model.standard_role_id}
                      onChange={(e) =>
                        setModel({
                          ...model,
                          standard_role_id: Number(e.target.value),
                        })
                      }
                    >
                      {roleList?.map((m: any, index: number) => (
                        <option key={index} value={m.id}>
                          {m.title}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Row>
                {/* Birth date, Death date */}
                <Row className="mt-3">
                  <Form.Group className="col-6">
                    <Form.Label>Birth Date</Form.Label>
                    <DatePicker
                      aria-required
                      disabled={model.action === Actions.delete}
                      className="form-control w-100"
                      format={"DD.MM.YYYY"}
                      onChange={(val) => {
                        const formattedDate = val
                          ? dayjs(val).format("YYYY-MM-DD")
                          : "";
                        setModel({
                          ...model,
                          birth_date: formattedDate,
                        });
                        setBirthDateValid(isDateValid(formattedDate));
                      }}
                      value={
                        model.birth_date &&
                          model.birth_date !== "" &&
                          model.birth_date !== "0000-00-00"
                          ? dayjs(model.birth_date, "YYYY-MM-DD")
                          : undefined
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {!birthDateValid && "Invalid date format."}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="col-6">
                    <Form.Label>Death Date</Form.Label>
                    <DatePicker
                      aria-required
                      disabled={model.action === Actions.delete}
                      className="form-control w-100"
                      format={"DD.MM.YYYY"}
                      onChange={(val) => {
                        const formattedDate = val
                          ? dayjs(val).format("YYYY-MM-DD")
                          : "";
                        setModel({
                          ...model,
                          death_date: formattedDate,
                        });
                        setDeathDateValid(isDateValid(formattedDate));
                      }}
                      value={
                        model.death_date &&
                          model.death_date !== "" &&
                          model.death_date !== "0000-00-00"
                          ? dayjs(model.death_date, "YYYY-MM-DD")
                          : undefined
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {!deathDateValid && "Invalid date format."}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                {/* Birth country, Death country */}
                <Row className="mt-3">
                  <Form.Group className="col-6">
                    <Form.Label>Country of Birth</Form.Label>
                    <Form.Select
                      disabled={model.action === Actions.delete}
                      value={model.birth_country_id}
                      onChange={(e) =>
                        setModel({ ...model, birth_country_id: e.target.value })
                      }
                    >
                      <option key={0} value={0}></option>
                      {countryList?.map((m: any, index: number) => (
                        <option key={index} value={m.id}>
                          {m.title}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="col-6">
                    <Form.Label>Country of Death</Form.Label>
                    <Form.Select
                      disabled={model.action === Actions.delete}
                      value={model.death_country_id}
                      onChange={(e) =>
                        setModel({ ...model, death_country_id: e.target.value })
                      }
                    >
                      <option key={0} value={0}></option>
                      {countryList?.map((m: any, index: number) => (
                        <option key={index} value={m.id}>
                          {m.title}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Row>
                {/* Birth Place, Death Place */}
                <Row className="mt-3">
                  <Form.Group className="col-6">
                    <Form.Label>Place of Birth</Form.Label>
                    <Form.Control
                      disabled={model.action === Actions.delete}
                      type="text"
                      value={model.birth_place ? model.birth_place : ""}
                      onChange={(e) =>
                        setModel({
                          ...model,
                          birth_place: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                  <Form.Group className="col-6">
                    <Form.Label>Place of Death</Form.Label>
                    <Form.Control
                      disabled={model.action === Actions.delete}
                      type="text"
                      value={model.death_place ? model.death_place : ""}
                      onChange={(e) =>
                        setModel({
                          ...model,
                          death_place: e.target.value,
                        })
                      }
                    />
                  </Form.Group>
                </Row>
                <Row className="mt-3">
                  <Form.Group className="col-6">
                    <Form.Label>Years Active</Form.Label>
                    {/* <TimePicker.RangePicker
                                        format={'HH:mm'}
                                        className="w-100"
                                        use12Hours
                                        value={model.worktime_from&&model.worktime_to?[dayjs(model.worktime_from, "HH:mm"), dayjs(model.worktime_to, "HH:mm")]:undefined}
                                        onChange={(time: any, timestring: string[])=>{
                                            setModel({...model, worktime_from: timestring[0], worktime_to: timestring[1]})
                                        }}
                                        disabledTime={(_, type:any)=>{
                                            let i;
                                            if(type==='start'){
                                                if(model.worktime_to){
                                                    let res: number[] = [];
                                                    for(i=dayjs(model.worktime_to, "HH:mm").get('hour');i<24;i++){
                                                        res.push(Number(i));
                                                    }
                                                    return {
                                                        disabledHours: () => res
                                                    };
                                                }
                                                return {};
                                            }else{
                                                if(model.worktime_from){
                                                    let res: number[] = [];
                                                    for(i=0;i<=dayjs(model.worktime_from, "HH:mm").get('hour');i++){
                                                        res.push(i);
                                                    }
                                                    return {
                                                        disabledHours: () => res
                                                    };
                                                }
                                                return {};
                                            }
                                        }}
                                    /> */}
                    <DatePicker.RangePicker
                      format={"DD.MM.YYYY"}
                      className="w-100"
                      value={
                        model.worktime_from && model.worktime_to
                          ? [
                            dayjs(model.worktime_from, "YYYY-MM-DD"),
                            dayjs(model.worktime_to, "YYYY-MM-DD"),
                          ]
                          : undefined
                      }
                      onChange={(date: any) => {
                        setModel({
                          ...model,
                          worktime_from: date[0].format("YYYY-MM-DD"),
                          worktime_to: date[1].format("YYYY-MM-DD"),
                        });
                      }}
                    />
                  </Form.Group>
                </Row>
                {/* homepage url, biography url */}
                <Row className="mt-3">
                  <Form.Group className="col-6">
                    <Form.Label>Homepage Url</Form.Label>
                    <Form.Control
                      disabled={model.action === Actions.delete}
                      type="text"
                      value={model.member_url ? model.member_url : ""}
                      onChange={(e) =>
                        setModel({ ...model, member_url: e.target.value })
                      }
                      onBlur={() => handleUrlValidation("member_url")}
                      isInvalid={isUrlValid("member_url")}
                    />

                    <Form.Control.Feedback type="invalid">
                      Please enter a valid URL.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="col-6">
                    <Form.Label>Biography Url</Form.Label>
                    <Form.Control
                      disabled={model.action === Actions.delete}
                      type="text"
                      value={model.bio_url ? model.bio_url : ""}
                      onChange={(e) =>
                        setModel({ ...model, bio_url: e.target.value })
                      }
                      onBlur={() => handleUrlValidation("bio_url")}
                      isInvalid={isUrlValid("bio_url")}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a valid URL.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                {/* Fan url, Merchandise url */}
                <Row className="mt-3">
                  <Form.Group className="col-6">
                    <Form.Label>Fan Url</Form.Label>
                    <Form.Control
                      disabled={model.action === Actions.delete}
                      type="text"
                      value={
                        model.fan_url && model.fan_url !== "null"
                          ? model.fan_url
                          : ""
                      }
                      onChange={(e) =>
                        setModel({ ...model, fan_url: e.target.value })
                      }
                      onBlur={() => handleUrlValidation("fan_url")}
                      isInvalid={isUrlValid("fan_url")}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a valid URL.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="col-6">
                    <Form.Label>Merchandise Url</Form.Label>
                    <Form.Control
                      disabled={model.action === Actions.delete}
                      type="text"
                      value={
                        model.merch_url && model.merch_url !== "null"
                          ? model.merch_url
                          : ""
                      }
                      onChange={(e) =>
                        setModel({ ...model, merch_url: e.target.value })
                      }
                      onBlur={() => handleUrlValidation("merch_url")}
                      isInvalid={isUrlValid("merch_url")}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please enter a valid URL.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <DefaultButton
              className="small-button"
              textColor="var(--color-primary)"
              color="white"
              borderColor="var(--color-primary)"
              onClick={closeModal}
            >
              Close
            </DefaultButton>
            <DefaultButton
              type="submit"
              className="small-button"
              color="var(--color-primary)"
              textColor="white"
              disabled={model.action === Actions.delete && model.message !== ""}
            >
              {model.action === Actions.add ? "Save" : model.action === Actions.edit ? "Save Changes" : "Delete"}
            </DefaultButton>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};
